import { ContextItem } from '@varos/assistant-sdk';
import { IntegrationDetailAggregate } from './integrationDetailModel';
import { assertNever } from '@varos/util-typescript';

export function buildMessageContext(
    item: Pick<IntegrationDetailAggregate, 'thread'>
): ContextItem[] {
    let context: ContextItem[] = [];

    // Add thread context if available (in addition to user-managed context)
    context.push(
        ...(item.thread.thread?.context.flatMap((item): ContextItem[] => {
            if (item.kind === 'reference' || item.kind === 'root') {
                return [
                    {
                        kind: item.kind,
                        data: {
                            document: item.document,
                        },
                    },
                ];
            }
            if (item.kind === 'prompt') {
                return [
                    {
                        kind: 'prompt',
                        data: {
                            text: item.prompt,
                        },
                    },
                ];
            }
            if (item.kind === 'task') {
                return [
                    {
                        kind: 'task',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'template') {
                return [
                    {
                        kind: 'template',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'collection') {
                return [
                    {
                        kind: 'collection',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'file') {
                return [
                    {
                        kind: 'file',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'resource') {
                return [
                    {
                        kind: 'resource',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'solution') {
                return [
                    {
                        kind: 'solution',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'form') {
                return [
                    {
                        kind: 'form',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'selection') {
                return [
                    {
                        kind: 'selection',
                        data: item,
                    },
                ];
            }
            if (item.kind === 'integration') {
                return [
                    {
                        kind: 'integration',
                        data: item,
                    },
                ];
            }
            assertNever(item);
        }) ?? [])
    );
    return context;
}
